import React from "react";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../../stores/PersonStore";
import PersonActions from "../../actions/PersonActions";

import { Elements } from "react-stripe-elements";
import PaymentMethodEntry from "./payment-method-entry.jsx";
import PaymentMethodEntryV2 from "./payment-method-entry-v2.jsx";

@connectToStores
class PaymentMethodUpdater extends React.Component {
  constructor(props) {
    super(props);
    this.submitPaymentInfo = this.submitPaymentInfo.bind(this);

    this.setPaymentMethodEntryRef = element => {
      this.paymentMethodEntry = element;
    };
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      isLarge: React.PropTypes.bool
    };
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  getStyles() {
    return {
      container: {}
    };
  }

  submitPaymentInfo(data) {
    if (this.props.onToken) {
      return this.props.onToken(data);
    }

    const newPaymentInfo =
      data.object === "setup_intent"
        ? { payment_method: data.payment_method }
        : { token: data.id };

    PersonActions.updatePaymentInfo(newPaymentInfo);

    if (this.props.onPaymentMethodUpdated) {
      this.props.onPaymentMethodUpdated();
    }
  }

  submitForm() {
    return this.paymentMethodEntry.onFormSubmit();
  }

  componentDidMount() {
    if (this.props.getRef) this.props.getRef(this);
  }

  render() {
    const styles = this.getStyles();

    return (
      <div style={styles.container}>
        <Elements>
          {!this.context.tenant.checkout_v2_optout ? (
            <PaymentMethodEntryV2
              getRef={this.setPaymentMethodEntryRef}
              onConfirm={this.submitPaymentInfo}
              onCancel={this.props.onCancel}
              submitButtonLabel={this.props.submitButtonLabel}
              submitButtonDisabled={this.props.submitButtonDisabled}
              paymentInfoUpdateInProgress={
                this.props.paymentInfoUpdateInProgress
              }
              paymentInfoUpdateErrorMessage={
                this.props.paymentInfoUpdateErrorMessage
              }
              setDisabledState={this.props.setDisabledState}
            ></PaymentMethodEntryV2>
          ) : (
            <PaymentMethodEntry
              onToken={this.submitPaymentInfo}
              onCancel={this.props.onCancel}
              submitButtonLabel={this.props.submitButtonLabel}
              paymentInfoUpdateInProgress={
                this.props.paymentInfoUpdateInProgress
              }
              paymentInfoUpdateErrorMessage={
                this.props.paymentInfoUpdateErrorMessage
              }
            />
          )}
        </Elements>
      </div>
    );
  }
}

export default PaymentMethodUpdater;



// WEBPACK FOOTER //
// ./src/app/components/partials/payment-method-updater.jsx